import { FuseAnimate } from "@fuse";
import { LinearProgress, Typography } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import { ReplaceAll } from "app/Core/Helpers";
import withReducer from "app/store/withReducer";
import queryString from "query-string";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { NovoAmbiente } from "./Store/Actions/AtualizandoActions";
import AtualizandoReducer from "./Store/Reducers/AtualizandoReducer";

const AtualizandoPage = () => {
    const dispatch = useDispatch();
    const { search } = document.location;
    const AQueryParsed = queryString.parse(search);
    const tentarNovamente = useSelector(({ Atualizando }) => Atualizando.tentarNovamente ?? false);
    const processando = useSelector(({ Atualizando }) => Atualizando.processando ?? false);

    useEffect(() => executar(), []);

    function executar() {
        if (!_.isNull(AQueryParsed.m)) {
            switch (AQueryParsed.m) {
                case "NovoAmbiente": dispatch(NovoAmbiente({ empresa: AQueryParsed.e })); break;
            }
        }
    }

    return (
        <div className="flex flex-col flex-1 items-center justify-center p-16">
            <div className="flex flex-col max-w-512 text-center items-center">
                <img
                    src="/assets/images/engrenagem.svg"
                    className="w-256"
                />
                <Typography variant="h4" color="textSecondary" className="mb-16">
                    {ReplaceAll(AQueryParsed.t, "+", " ")}
                </Typography>

                {!processando && tentarNovamente &&
                    <XAPPButton
                        type="Button"
                        className="my-8"
                        onClick={(ev) => executar()}
                        variant="contained"
                        iconProps={"mr-8"}
                        icon={"refresh"}
                        label={"Tentar novamente"}
                        key={"tentarNovamente"}
                    />
                }
                {processando ?
                    <LinearProgress className="w-xs my-8" color="secondary" />
                    :
                    <Link className="font-medium mt-12" to="/pub-login">Voltar ao início</Link>
                }
            </div>
        </div>
    );
};

export default withReducer('Atualizando', AtualizandoReducer)(AtualizandoPage);